<template>
  <section class="gratitude-body">
    <h1 class="title">
      ¡Muchas gracias, {{ $store.getters.getPersonForm.name }}!
    </h1>
    <p class="subtitle">
      Dentro de las proximas 24 horas te va a contactar un asesor comercial de
      OSFATUN.
    </p>
  </section>
</template>

<script>
export default {
  name: "Gratitude",
  created() {
    this.$gtag.pageview({ page_title: "Gracias", page_path: "/gracias" });
  },
};
</script>

<style scoped>
.gratitude-body {
  position: relative;
  top: -10vh;
  background: white;
  max-width: 60%;
  padding: 70px 30px;
  margin: 0 auto;
}
h1.title {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}
.subtitle {
  font-size: 20px;
  color: #00758f;
}
</style>
